module.exports = __webpack_public_path__ + "img/red_046.f25ba62c.png";